module.exports = __webpack_public_path__ + "static/media/BrittaKammerer.7bc8a25a.jpg";